import { HiOutlineClipboardList } from "react-icons/hi";
import { AdvisorRoutes } from "@common/constants";
import { useViewAsAdvisor } from "@common/hooks";
import { useWorkItems } from "@modules/cases-tasks/queries";
import { toWorkItems } from "@modules/cases-tasks/utils";
import SidebarLink from "../Sidebar/SidebarLink";

interface CasesTasksSidebarLinkProps {
  onClickLink?: () => void;
}

// A component rather than a bare <SidebarLink> because the badge needs useWorkItems, and
// hooks can't be conditional — but mounting can, so the caller's flag check keeps the
// query from firing without access.
const CasesTasksSidebarLink = ({ onClickLink }: CasesTasksSidebarLinkProps) => {
  const { viewAs } = useViewAsAdvisor();
  // Same query key the page uses, so while impersonating the badge counts the advisor
  // being viewed rather than the admin's own book — and reuses the page's cached data
  // instead of firing a second request.
  const { data } = useWorkItems(viewAs);
  const openCount = toWorkItems(data).length;

  return (
    <SidebarLink
      href={AdvisorRoutes.CasesAndTasks}
      icon={<HiOutlineClipboardList />}
      text="Cases & Tasks"
      badgeCount={openCount}
      // Carry the impersonation across the navigation, or the destination silently
      // falls back to the admin's own book.
      query={viewAs ? { viewAs } : undefined}
      onClickLink={onClickLink}
    />
  );
};

export default CasesTasksSidebarLink;
